@use '@/sass/variables';

.SamplePlanTable {
  --table-selection-column: 3rem;
  --table-expand-column: 4.5rem;
  --table-default-column-min-width: 15rem;
  --table-sample-name-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-group-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-planned-animal-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-registered-animal-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-sample-type-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-timepoints-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-calculate-collection-time-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-detail-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-metadata-column: minmax(var(--table-default-column-min-width), 1fr);
  --table-planned-samples-count: minmax(var(--table-default-column-min-width), 1fr);
  --table-collected-samples-count: minmax(var(--table-default-column-min-width), 1fr);

  display: grid;
  grid-template-columns:
    var(--table-expand-column) var(--table-sample-name-column) var(--table-group-column) var(
      --table-planned-animal-column
    )
    var(--table-registered-animal-column) var(--table-sample-type-column) var(--table-timepoints-column) var(
      --table-calculate-collection-time-column
    );
  grid-template-rows: 1fr;
  border-top: variables.$border-width-apitable solid variables.$moon-gray;
  background: variables.$white;
  max-height: 600px;
  overflow: auto;
  scroll-behavior: smooth;

  > div {
    display: contents;

    > div {
      padding: variables.$font-size-6;
      border-right: variables.$border-width-apitable solid variables.$moon-gray;
      border-bottom: variables.$border-width-apitable solid variables.$moon-gray;
      display: flex;
      align-items: center;
      min-height: 55px;
      font-size: 0.875rem;
      color: variables.$near-black;

      &:last-child {
        border-right: none;
      }
    }
  }

  .Header {
    > div {
      background: variables.$light-gray;
      font-weight: 500;
      font-size: 0.925rem;
      color: variables.$near-black;
      user-select: none;
      position: sticky;
      top: 0;
      z-index: 10;

      &:last-child {
        border-top-right-radius: variables.$border-radius-2;
      }
    }
  }

  .SampleDefinitionRow {
    > div {
      background: variables.$white;
    }
  }

  .GroupRow {
    display: contents;
  }

  .AnimalRow {
    display: contents;
  }
}

.ChevronCell {
  cursor: pointer;
  user-select: none;
  transition:
    transform 0.2s ease,
    color 0.2s ease;

  svg {
    transition: transform 0.2s ease;
    transform-origin: center;
  }

  &:hover {
    color: variables.$dark-blue;
  }
}

.ChevronCell.Disabled {
}

.ChevronCell.Open {
  svg {
    transform: rotate(90deg);
  }
}

.ChevronCell.Closed {
  svg {
    transform: rotate(0deg);
  }
}

.SelectionBadge {
  white-space: nowrap;
  height: 2.5rem;
  display: flex;
  align-items: center;
}
